
import { defineComponent, PropType } from 'vue'
import { RunReport, RunReportGrade } from '~/types/types'

interface DimensionConfig {
  key: string
  label: string
  icon: string
  grade: RunReportGrade | 'undefined'
}

const DIMENSION_META: Record<string, { label: string; icon: string }> = {
  security: { label: 'Security', icon: 'security' },
  reliability: { label: 'Reliability', icon: 'pulse' },
  complexity: { label: 'Complexity', icon: 'bug-brace' },
  hygiene: { label: 'Hygiene', icon: 'clean' },
  coverage: { label: 'Coverage', icon: 'coverage' }
}

const DIMENSION_KEYS = Object.keys(DIMENSION_META)

export default defineComponent({
  name: 'ReportCardDetail',
  props: {
    reportCard: {
      type: Object as PropType<RunReport>,
      required: true
    },
    isDefaultBranch: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    dimensions(): DimensionConfig[] {
      return DIMENSION_KEYS.map((key) => {
        const dim = this.reportCard[key as keyof RunReport] as
          | { grade?: RunReportGrade }
          | undefined
        return {
          key,
          label: DIMENSION_META[key].label,
          icon: DIMENSION_META[key].icon,
          grade: dim?.grade ?? 'undefined'
        }
      })
    },
    focusAreaLabel(): string {
      const dim = this.reportCard.focusArea?.dimension
      if (!dim) return ''
      return DIMENSION_META[dim.toLowerCase()]?.label ?? dim
    }
  }
})
